<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  >
    <template #ORDERDETAIL="{ params, visible }">
      <order
        v-if="visible"
        :orderDetails="params.dataDetails"
        :pageText="params.pageText"
        :footer-hide="false"
      ></order>
    </template>
    <template #SHOWORDERLIST>
      <Tag type="dot" v-for="(item, idx) in list" :key="idx" color="primary">{{
        item
      }}</Tag>
    </template>
    <template #SHOWSTATUS>
      <order-tracker v-if="statusId" :statusId="statusId"></order-tracker>
    </template>
  </cTable>
</template>

<script>
import {
  getSubcontractForecastList,
  getAbnormalOrder,
  addRemark,
  addFinishTime,
  getServiceType,
  getBagOrder,
  getBoxOrder,
  addInstructionFile,
  uploadSignSrc,
  inTransitOrder
} from "@/api/forecastManagement/subcontractForecastList";
import { getCountry } from "@/api/system/country";
// import { getSelectType } from "@/api/public";
// import { getUser } from "@/api/user/internal";
// import { getChannel } from "@/api/tracker/channel";
// import { getAgent } from "@/api/tracker/agent";
// import { getStatus } from "@/api/tracker/status";
import { getAllClient } from "@/api/user/client";
import orderTracker from "@/base/order_tracker";
import { getUser, getAllService } from "@/api/user/internal";
import cTable from "@/base/common/index";
import expandRow from "./template/index";
// import format from "@/utils/format";
// import expandRow from "_my/table-expand";
import copyClick from "@/utils/copyClick";
import order from "_c/order-details";
import { getSelectType, getKeysType } from "@/api/public";
import { getOrderDetails } from "@/api/order/list";
export default {
  name: "subcontractForecastList",
  components: {
    cTable,
    order,
    orderTracker
  },
  data() {
    let that = this;
    return {
      list: [],
      statusId: "",
      methods: {
        list: p => {
          return getSubcontractForecastList(p);
        },
        getAbnormalOrder,
        addRemark,
        addFinishTime,
        // afterHandleList({ list }) {
        //   list.forEach(item => {
        //     this.getTable().setRowExpand(item, item.child.length > 0);
        //   });
        // }
        getCountry,
        // getAgent,
        getAllClient,
        getServiceType,
        getBagOrder,
        getBoxOrder,
        addInstructionFile,
        getOrderDetails,
        uploadSignSrc
        // getChannel,
        // getSelectType
      },
      config: {
        height: 630,
        showOverflow: false,
        // children: true,
        rowId: "id",
        expandConfig: {
          // expandAll: true,
          // reserve: true,
          accordion: true,
          visibleMethod: ({ row }) => {
            if (row.child.length) return true;
          }
        }
      },
      modals: {
        showBoxList: {
          config: {
            modalBind: {
              width: 600
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          footer: {
            show: false
          },
          fields: [],
          table: {
            config: {
              height: 600
            },
            fields: [
              {
                name: () => this.$t("order_number"),
                key: "airway_bill_number",
                copy: true,
                header: {
                  copy: true //头部复制
                },
                tooltip: true,
                minWidth: 100
              },
              {
                type: "btns",
                width: 250,
                name: () => this.$t("operation"),
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("show"),
                    type: "boxOrder",
                    fnName: "boxOrderFun",
                    bind: {
                      type: "warning"
                    }
                  }
                ],
                methods: {
                  boxOrderFun({ row }) {
                    window.open(this.$prviewUrl + row.src);
                  }
                }
              }
            ]
          },
          methods: {
            ok() {
              let obj = {
                name: this.$t("bagList"),
                fields: this.table.fields,
                data: this.list
              };
              this.$page.exportExc(obj);
            }
          }
        },
        showOrderList: {
          config: {
            listFn: "list",
            modalBind: {
              width: 600
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          footer: {
            ok: {
              name: () => this.$t("export")
            },
            cancel: {}
          },
          fields: [],
          table: {
            config: {
              height: 600
            },
            fields: [
              {
                name: () => this.$t("order_number"),
                key: "airway_number",
                copy: true,
                header: {
                  copy: true //头部复制
                },
                tooltip: true,
                minWidth: 100
              },
              {
                name: () => this.$t("bagCode"),
                key: "package_number",

                tooltip: true,
                minWidth: 100
              }
            ]
          },
          methods: {
            ok() {
              let obj = {
                name: this.$t("bagList"),
                fields: this.table.fields,
                data: this.list
              };
              this.$page.exportExc(obj);
            }
          }
        },
        showOrderTag: {
          contentSlot: "SHOWORDERLIST",
          config: {
            width: 600
          },
          footer: {
            ok: {
              name: () => this.$t("copy")
            },
            cancel: {}
          },
          methods: {
            ok: () => {
              let data = this.list.map(item => item).join("\r\n");
              copyClick.copyToClipboard(data, this);
            }
          }
        },
        showstatus: {
          contentSlot: "SHOWSTATUS",
          methods: {
            cancel: ({ close }) => {
              this.statusId = "";
            }
          },
          footer: {
            show: false
          }
        },
        orderDetail: {
          contentSlot: "ORDERDETAIL",
          config: {
            listFn: "list",
            modalBind: {
              width: "80%"
            }
          },
          footer: {
            show: false
          }
        },
        show: {
          config: {
            modalBind: {
              width: 600
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          footer: {
            show: false
          },
          fields: [],
          table: {
            config: {
              height: 600
            },
            // footer: {
            //   show: true
            // },
            fields: [
              {
                name: () => this.$t("order_number"),
                key: "airway_number",
                align: "center",
                tooltip: true,
                minWidth: 100
              },
              {
                name: () => this.$t("bagCode"),
                key: "package_number",
                align: "center",
                tooltip: true,
                minWidth: 100
              }
            ]
          }
        },
        remark: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("addRemark", row, true)
                .then(res => {
                  console.log(this);
                  this.$page.list.forEach(el => {
                    if (el._XID == row._XID) {
                      el.child.forEach(item => {
                        if (
                          item.packing_number == row.packing_number &&
                          el.airway_number == row.airway_number
                        )
                          item[row.type] = row.remark;
                      });
                    }
                  });
                  // this.getList();
                  close();
                });
            }
          },
          config: {
            rules: {
              remark: [
                {
                  required: true,
                  message: "remarks be empty",
                  trigger: "bulr"
                }
              ]
            },
            formBind: {
              labelWidth: 60
            },
            title: this.$t("add") + this.$t("order_desc"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{ remark: 24 }],
          fields: [
            {
              key: "remark",
              name: () => this.$t("order_desc"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              },
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        },
        settime: {
          type: "add",
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("addFinishTime", row, true)
                .then(e => {
                  this.$page.list.forEach(el => {
                    if (el._XID == row._XID) {
                      el.child.forEach(item => {
                        if (
                          item.packing_number == row.packing_number &&
                          el.airway_number == row.airway_number
                        )
                          item.complete_time = row.complete_time;
                      });
                    }
                  });
                  // this.$page.getList();
                  close();
                });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            modalBind: {
              width: 400
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              complete_time: [
                {
                  required: true,
                  message: "Please select the date and Time",
                  trigger: "change",
                  type: "date"
                }
              ]
            }
          },
          grid: [{ complete_time: 24 }],
          fields: [
            {
              key: "complete_time",
              name: () =>
                this.$t("select") + this.$t("complete") + this.$t("time"),
              component: "DatePicker",
              placeholder() {
                return (
                  this.$t("select") + this.$t("complete") + this.$t("time")
                );
              },
              bind: {
                type: "datetime",
                options: {
                  disabledDate(time) {
                    return time.getTime() > Date.now();
                  }
                },
                clearable: false
              }
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              }
            }
          },
          {
            key: "customer_service_id",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("serviceAccount");
            },
            options: []
          },
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" },
            bind: {
              multiple: true,
              "max-tag-count": 1,
              style: "width:150px"
            }
          },
          {
            key: "from_country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("allow_depart");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "to_country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("allow_arrive");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "complete",
            component: "Select",
            placeholder() {
              return this.$t("whether") + this.$t("complete");
            },
            clearable: true,
            options: [
              { label: this.$t("YES"), value: "YES" },
              {
                label: this.$t("NO"),
                value: "NO"
              }
            ],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "sign_receipt",
            component: "Select",
            placeholder() {
              return this.$t("whether") + this.$t("pod");
            },
            clearable: true,
            options: [
              { label: this.$t("YES"), value: "YES" },
              {
                label: this.$t("NO"),
                value: "NO"
              }
            ],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "is_unpack_finish",
            component: "Select",
            placeholder() {
              return this.$t("isUnpack") + this.$t("complete");
            },
            clearable: true,
            options: [
              { label: this.$t("YES"), value: "YES" },
              { label: this.$t("NO"), value: "NO" }
            ],
            bind: {
              style: "width:120px"
            }
          },
          {
            key: "out_warehouse",
            component: "Select",
            placeholder() {
              return (
                this.$t("whether") + this.$t("whole") + this.$t("outbound")
              );
            },
            clearable: true,
            options: [
              { label: this.$t("YES"), value: "YES" },
              { label: this.$t("NO"), value: "NO" }
            ],
            bind: {
              style: "width:120px"
            }
          },
          {
            key: "is_exception",
            component: "Select",
            placeholder() {
              return this.$t("whether") + this.$t("abnormal");
            },
            clearable: true,
            options: [
              { label: this.$t("YES"), value: "YES" },
              { label: this.$t("NO"), value: "NO" }
            ],
            bind: {
              style: "width:120px"
            }
          },

          {
            key: "service_project",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("serviceType");
            },
            options: [],
            config: { label: "service_name", value: "service_code" }
          },
          {
            key: "keywordsType",
            placeholder() {
              return this.$t("select") + this.$t("keywords_type");
            },
            clearable: false,
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType("UNPACK_FORECAST_KEYWORDS")).data
                  .payload["UNPACK_FORECAST_KEYWORDS"];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              style: "width:140px",
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              // disabled() {
              //   return !this.selectAll.length;
              // },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            },
            {
              name: () => this.$t("ReceiptSign") + this.$t("updateFile"),
              type: "3",
              fnName: "updateFile",
              bind: {
                icon: "ios-cloud-upload",
                type: "warning"
              },
              id: 1651
            }
          ],
          methods: {
            updateFile({ field }) {
              let el = document.createElement("input");
              let extend = [];
              let length = 0;
              el.type = "file";
              el.multiple = true;
              el.click();
              el.addEventListener("input", e => {
                let formData = new FormData();
                let list = Object.values(el.files).map(t => {
                  formData.append("files[]", t);
                });
                this.handleRequestMethods(
                  "uploadSignSrc",
                  formData,
                  true,
                  true
                ).then(res => {
                  console.log(res);
                });
              });
            },
            export() {
              let airway_number = this.selectAll.map(
                item => item.airway_number
              );
              this.handleRequestMethods(
                "list",
                {
                  export: "YES",
                  airway_number,
                  page: this.pageConfig.page,
                  pageSize: this.pageConfig.size,
                  ...this.$refs["header"].searchForm
                },
                true,
                true
              ).then(res => {
                window.open(this.$globalUrl + res.payload.path);
              });
            }
          }
        }
      },
      fields: [
        // {
        //   width: 35,
        //   type: "expand",
        //   showOverflow: false,
        //   fixed: "left",
        //   expandRender: (h, p) => {
        //     return h(expandRow, {
        //       props: {
        //         row: p.row.child,
        //         airway_number: p.row.airway_number
        //       }
        //     });
        //   },
        //   fnName: "expandFun",
        //   methods: {
        //     expandFun({ row }) {
        //       console.log(row);
        //       return row.id;
        //     }
        //   }
        // },
        {
          type: "checkbox",
          align: "center",
          fixed: "left",
          width: 60
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_number",
          align: "center",
          fixed: "left",
          width: 180,
          tooltip: false,
          copy: true,
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          header: {
            copy: true
          },
          methods: {
            render: ({ value }) => {
              return value;
            },
            click({ row }) {
              // console.log("this", this);
              // this.$page.$parent.statusId = row.airway_number;
              // this.$page
              //   .getModal("showstatus")
              //   .setTitle(
              //     row.airway_number + "(" + this.$t("trajectory") + ")"
              //   );
              // this.$page.getModal("showstatus").open(row.airway_number);
              this.$page
                .handleRequestMethods("getOrderDetails", row.airway_number)
                .then(res => {
                  this.$page.getModal("orderDetail").open(
                    {
                      dataDetails: res.payload,
                      pageText: "all"
                    },
                    function() {
                      this.setTitle(row.airway_number);
                    }
                  );
                });
            }
          }
        },
        {
          name: () => this.$t("serviceAccount"),
          key: "service_name",
          fixed: "left",
          width: 100
        },
        {
          name: () => this.$t("account_name"),
          key: "client_name",
          fixed: "left",
          width: 100
        },
        {
          name: () => this.$t("company_name"),
          key: "shipper_company_cn",
          fixed: "left",
          width: 130
        },
        {
          name: () => this.$t("company"),
          key: "consignee",
          align: "center",
          width: 100
        },
        {
          name: () => this.$t("from_station"),
          key: "from_country",
          width: 100
        },
        {
          name: () => this.$t("to_station"),
          align: "center",
          key: "to_country",
          width: 100
        },

        {
          name: () => this.$t("Total Ctns"),
          align: "center",
          key: "quantity",
          width: 100
        },
        {
          name: () => this.$t("Total Quantity"),
          key: "goods_quantity",
          width: 100
        },
        {
          name: () => this.$t("total_out_ticket_nums"),
          key: "unpackAwbNumber",
          width: 100
        },
        {
          name: () => this.$t("Pening outbound"),
          key: "notShipped",
          width: 100
        },
        {
          name: () => this.$t("wheather finished outbound"),
          key: "out_warehouse",
          width: 100
        },
        {
          name: () => this.$t("UnpackedFinished"),
          key: "isUnpackFinish",
          minWidth: 110
          // methods: {
          //   render({ value }) {
          //     return value ? this.$t("YES") : this.$t("NO");
          //   },
          // },
        },
        {
          name: () => this.$t("shipmentBatch"),
          key: "batch_name",
          type: "child",
          child: { list: "child" },
          width: 80
        },
        {
          name: () => this.$t("shipmentTicket"),
          key: "awbTotal",
          type: "child",
          child: { list: "child" },
          minWidth: 80
        },
        {
          name: () => this.$t("shipmentNumber"),
          key: "out_quantity",
          type: "child",
          child: { list: "child" },
          minWidth: 80
        },
        {
          name: () => this.$t("shipmentWeight"),
          key: "total_check_weight",
          type: "child",
          child: { list: "child" },
          minWidth: 80
        },
        // {
        //   name: () => this.$t("shipmentNumber") + "(PCS)",
        //   key: "deliver_weight",
        //   minWidth: 130
        // },
        {
          name: () => this.$t("shipmentTime"),
          key: "outbound_time",
          type: "child",
          child: { list: "child" },
          minWidth: 150
        },
        {
          name: () => this.$t("customsBill"),
          key: "packing_number",
          type: "child",
          child: { list: "child" },
          minWidth: 130
        },
        {
          name: () => this.$t("MAWB NO."),
          key: "mawb",
          minWidth: 130,
          type: "child",
          child: { list: "child" }
        },
        {
          name: () => this.$t("bagCode"),
          key: "package_number",
          minWidth: 130,
          type: "child",
          child: { list: "child", isToTip: true, component: "Button" },
          bind: {
            type: "primary",
            size: "small"
          },
          methods: {
            async click({ row, parent }) {
              let list = (
                await getBagOrder({
                  package_number: row.package_number,
                  airway_number: parent.airway_number
                })
              ).data.payload;
              this.$page.getModal("showOrderList").open(null, function() {
                this.list = list;
                this.setTitle(this.$t("show") + this.$t("bagList"));
              });
            },
            render({ row }) {
              return row.package_number;
            }
          }
        },
        {
          name: () => this.$t("takeOffTime"),
          key: "depart_date",
          type: "child",
          child: { list: "child" },
          minWidth: 150
        },
        {
          name: () => this.$t("arrivalTime"),
          key: "arrival_date",
          type: "child",
          child: { list: "child" },
          minWidth: 150
        },
        {
          name: () => this.$t("clearance_date"),
          key: "clearance_date",
          type: "child",
          child: { list: "child" },
          minWidth: 150
        },
        {
          name: () => this.$t("receiptTime"),
          key: "pod_time",
          type: "child",
          child: { list: "child" },
          minWidth: 150
        },
        {
          name: () => this.$t("onTheWayTicket"),
          key: "onTheWay",
          type: "child",
          minWidth: 100,
          child: { list: "child", isToTip: true, component: "Button" },
          bind: {
            type: "primary",
            size: "small"
          },
          methods: {
            click: async ({ row, parent }) => {
              if (!this.$hasPermission(1837)) return;
              let list = (
                await inTransitOrder({
                  packing_number: row.packing_number,
                  airway_number: parent.airway_number
                })
              ).data.payload;
              this.list = list;
              this.$refs.table.getModal("showOrderTag").open(null, function() {
                this.setTitle(this.$t("show") + this.$t("bagList"));
              });
            }
          }
        },
        {
          name: () => this.$t("receiptTicket"),
          key: "podTotal",
          type: "child",
          child: { list: "child" },
          minWidth: 100
        },
        {
          name: () => this.$t("WAbnormal"),
          key: "is_exception",
          type: "child",
          child: { list: "child" },
          minWidth: 100
        },
        {
          name: () => this.$t("abnormal bills"),
          key: "exceptionTotal",
          minWidth: 100,
          type: "child",
          child: { list: "child", component: "Button" },
          bind: {
            type: "primary",
            size: "small"
          },
          methods: {
            click({ row, parent }) {
              this.$page
                .getModal("show")
                .open(parent.airway_number, function() {
                  this.$page
                    .handleRequestMethods(
                      "getAbnormalOrder",
                      {
                        packing_number: row.packing_number,
                        airway_number: parent.airway_number
                      },
                      false,
                      true
                    )
                    .then(res => {
                      this.list = res.payload;
                    });
                  this.setTitle(
                    this.$t("show") +
                      this.$t("abnormal") +
                      this.$t("order_t") +
                      row.packing_number
                  );
                });
            }
          }
        },
        {
          name: () => this.$t("downloadReceipt"),
          key: "instruction_link",
          minWidth: 120,
          bind: {
            type({ row }) {
              return row.is_special == 1 ? "success" : "primary";
            },
            size: "small"
          },
          disabled: ({ row }) => !row.sign_src,
          component: "Button",
          methods: {
            click({ row }) {
              window.open(row.sign_src);
            },
            render({ value }) {
              return this.$t("show");
            }
          }
        },
        /* {
          name: () => this.$t("unpack") + this.$t("instructionFile"),
          key: "instruction_link",
          minWidth: 120,
          type: "child",
          child: { list: "child", isToTip: true, component: "Upload" },
          bind: {
            type: "success",
            size: "small",
          },
          methods: {
            beforeUpload({ file, row, parent }) {
              let formData = new FormData();
              formData.append("file", file);
              formData.append("airway_number", parent.airway_number);
              formData.append("packing_number", row.packing_number);
              this.$page
                .handleRequestMethods(
                  "addInstructionFile",
                  formData,
                  true,
                  true
                )
                .then((res) => {
                  this.$page.list.forEach((el) => {
                    console.log(el);
                    if (el._XID == row._XID) {
                      el.child.forEach((item) => {
                        if (
                          item.packing_number == row.packing_number &&
                          el.airway_number == parent.airway_number
                        ) {
                          item.instruction_link = res.payload.path;
                        }
                      });
                    }
                  });
                });
            },
          },
        }, */
        {
          name: () => this.$t("instruction"),
          key: "remark_instruction",
          minWidth: 100,
          type: "child",
          child: { list: "child", isToTip: true, component: "Button" },
          bind: {
            type: "success",
            size: "small"
          },
          methods: {
            click({ row, parent }) {
              let data = {
                airway_number: parent.airway_number,
                packing_number: row.packing_number,
                remark: row.remark_instruction,
                type: "remark_instruction",
                _XID: parent._XID
              };
              this.$page.getModal("remark").open(data, function() {
                this.setTitle(
                  row.remark_instruction
                    ? this.$t("update")
                    : this.$t("add") + this.$t("instruction")
                );
              });
            },
            render({ row }) {
              return row.remark_instruction
                ? row.remark_instruction
                : this.$t("addTo");
            }
          }
        },
        {
          name: () => this.$t("warehouse remark"),
          key: "warehouse_remark",
          type: "child",
          child: { list: "child" },
          minWidth: 100
        },

        {
          name: () => this.$t("orther") + this.$t("order_desc"),
          key: "other_remark",
          minWidth: 100,
          type: "child",
          child: { list: "child", isToTip: true, component: "Button" },
          bind: {
            type: "success",
            size: "small"
          },
          methods: {
            click({ row, parent }) {
              let data = {
                airway_number: parent.airway_number,
                packing_number: row.packing_number,
                remark: row.other_remark,
                type: "other_remark",
                _XID: parent._XID
              };
              this.$page.getModal("remark").open(data, function() {
                this.setTitle(
                  row.other_remark
                    ? this.$t("update")
                    : this.$t("add") + this.$t("orther") + this.$t("order_desc")
                );
              });
            },
            render({ row }) {
              return row.other_remark ? row.other_remark : this.$t("addTo");
            }
          }
        },
        {
          name: () => this.$t("finish time"),
          key: "complete_time",
          minWidth: 150,
          type: "child",
          child: { list: "child", component: "Button" },
          bind: {
            type: "success",
            size: "small"
          },
          methods: {
            click({ row, parent }) {
              let data = {
                airway_number: parent.airway_number,
                packing_number: row.packing_number,
                complete_time: row.complete_time
                  ? row.complete_time
                  : new Date(),
                _XID: parent._XID
              };
              this.$page.getModal("settime").open(data, function() {
                this.setTitle(
                  row.complete_time
                    ? this.$t("update")
                    : this.$t("add") + this.$t("finish time")
                );
              });
            },
            render({ row }) {
              return row.complete_time ? row.complete_time : this.$t("addTo");
            }
          }
        },
        {
          name: () => this.$t("addReceipt"),
          key: "sign_receipt",
          type: "child",
          child: { list: "child", component: "Upload", isNoUpload: true },
          minWidth: 100
        },
        {
          type: "btns",
          width: 250,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => "B2b" + this.$t("boxOrder"),
              type: "boxOrder",
              fnName: "boxOrderFun",
              bind: {
                type: "warning"
              }
            }
          ],
          methods: {
            boxOrderFun({ row }) {
              getBoxOrder({ airway_number: row.airway_number }).then(res => {
                this.getModal("showBoxList").open(null, function() {
                  this.setTitle("B2b" + this.$t("boxOrder"));
                  this.list = res.data.payload;
                });
              });
            }
          }
        }
      ]
    };
  },
  copy() {
    let data = this.list.join("\r\n");
    copyClick.copyToClipboard(data, this);
  },
  async mounted() {
    let data = (await getAllService()).data.payload;
    this.header.searchs.forEach(async item => {
      if (item.key === "client_id")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "to_country" || item.key === "from_country")
        item.options = (await getCountry()).data.payload.rows;
      if (item.key === "customer_service_id") item.options = data[2];
      // if (item.key === "deliver")
      //   item.options = (
      //     await getAgent({
      //       agent_type: "bag",
      //       status: "YES",
      //       types: "DELIVERY"
      //     })
      //   ).data.payload.rows;
      // if (item.key === "frequency")
      //   item.options = (
      //     await getSelectType(["TIME_OUT_NOT_DELIVERY"])
      //   ).data.payload["TIME_OUT_NOT_DELIVERY"];
      if (item.key === "service_project")
        item.options = (await getServiceType()).data.payload;
    });
  }
};
</script>
